import React from "react";
import ReactParallaxTilt from "react-parallax-tilt";

import "./Arranged.scss";

import toothbrush from "./assets/img/toothbrush.png";
import leafTop from "./assets/img/leaf-top.png";
import leafBot from "./assets/img/leaf-bottom.png";
import arrowTop from "./assets/img/arrow-top.png";
import arrowMid from "./assets/img/arrow-middle.png";
import arrowBot from "./assets/img/arrow-bottom.png";

const Arranged = () => {
  return (
    <section className="arranged">
      <div className="container">
        <div className="arranged-wrapper">
          <h2 className="section-title arranged__title">
            <div className="red">Как</div> устроены наши щетки
          </h2>
          <div className="arranged-box">
            <ReactParallaxTilt
              tiltMaxAngleX={15}
              tiltMaxAngleY={15}
              perspective={1000}
              transitionSpeed={1500}
              scale={1.1}
              gyroscope={true}
            >
              <img
                className="arranged__image"
                src={toothbrush}
                alt="Устройство щеток"
              />
              <img
                className="absolute"
                src={leafTop}
                alt="Декоративные элементы щетки"
                id="leaf-top"
              />
              <img
                className="absolute"
                src={leafBot}
                alt="Декоративные элементы щетки"
                id="leaf-bottom"
              />
            </ReactParallaxTilt>
            <div className="absolute" id="arrow-top">
              <img src={arrowTop} alt="Декоративные элементы щетки" />
              <span>Перерабатываемая щетина</span>
            </div>

            <div className="absolute" id="arrow-middle">
              <img src={arrowMid} alt="Декоративные элементы щетки" />
              <span>СО2-нейтральное производство зубных щеток</span>
            </div>

            <div className="absolute" id="arrow-bottom">
              <img src={arrowBot} alt="Декоративные элементы щетки" />
              <span>Не содержит ПВХ, латекс и&nbsp;бисфенол А</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Arranged;
